var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMustashol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4930_4084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0634 2.69893C12.9341 2.93881 12.8229 3.18858 12.7315 3.44553C12.257 3.28426 11.7419 3.28426 11.2674 3.44553C11.176 3.18858 11.0652 2.93926 10.9355 2.69893C11.624 2.4568 12.3749 2.4568 13.0634 2.69893Z",
    stroke: "#64B98B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 14.9457C12.0008 14.9457 12.7239 17.8508 16.7004 17.8508C19.4405 17.8508 20.5183 15.5558 20.8799 14.4449C20.9172 14.324 20.8889 14.1929 20.8056 14.0981C20.7218 14.0033 20.5953 13.9584 20.4706 13.9799C17.0565 14.5208 16.9174 10.5879 14.17 10.5879C13.3155 10.5892 12.5114 10.9931 12.0013 11.6772C11.4911 10.9931 10.687 10.5892 9.83248 10.5879C7.08515 10.5879 6.94828 14.5208 3.5319 13.9799C3.40718 13.9584 3.28022 14.0033 3.19692 14.0981C3.11363 14.1929 3.08527 14.324 3.12264 14.4449C3.48417 15.5558 4.56249 17.8508 7.30216 17.8508C11.2782 17.8508 12.0008 14.9457 12.0008 14.9457Z",
    stroke: "#64B98B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21888 23.3992C6.85869 23.5578 6.44313 23.5277 6.1095 23.3183C5.73806 23.0722 5.5188 22.653 5.5287 22.2083V19.9519C5.5179 19.5063 5.73671 19.0863 6.1086 18.8392C6.29725 18.7211 6.51562 18.6577 6.73848 18.6577C6.90372 18.6582 7.06715 18.6928 7.21843 18.7588L10.1387 20.0179C10.2859 20.0822 10.3813 20.2273 10.3813 20.3881V21.7703C10.3813 21.9307 10.2863 22.0763 10.1387 22.1405L7.21843 23.4001L7.21888 23.3992ZM11.1908 21.8858V20.2718C11.1908 20.0489 11.3718 19.8684 11.5952 19.8684H12.4042C12.6275 19.8684 12.8085 20.0489 12.8085 20.2718V21.8858C12.8085 22.1086 12.6275 22.2892 12.4042 22.2892H11.5952C11.3718 22.2892 11.1908 22.1086 11.1908 21.8858ZM18.4702 22.273C18.4747 22.6692 18.2838 23.0421 17.9601 23.2712C17.5824 23.4931 17.1236 23.5299 16.7148 23.3713L13.8594 22.14C13.7122 22.0758 13.6167 21.9307 13.6167 21.7699V20.3876C13.6167 20.2273 13.7117 20.0817 13.8594 20.0175L16.7134 18.7862C17.1218 18.6276 17.581 18.6645 17.9588 18.8864C18.2829 19.1155 18.4738 19.4883 18.4698 19.8845L18.4702 22.273Z",
    stroke: "#64B98B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7868 5.34211C10.7868 8.0163 8.61392 10.1842 5.93368 10.1842C3.25343 10.1842 1.08105 8.0163 1.08105 5.34211C1.08105 2.66792 3.25343 0.5 5.93368 0.5C7.2209 0.5 8.45544 1.01031 9.36536 1.91818C10.2757 2.82604 10.7868 4.0578 10.7868 5.34211Z",
    stroke: "#64B98B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9186 5.34211C22.9186 8.0163 20.7462 10.1842 18.066 10.1842C15.3857 10.1842 13.2129 8.0163 13.2129 5.34211C13.2129 2.66792 15.3857 0.5 18.066 0.5C19.3527 0.5 20.5873 1.01031 21.4972 1.91818C22.4076 2.82604 22.9186 4.0578 22.9186 5.34211Z",
    stroke: "#64B98B",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4930_4084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustashol);
export default __webpack_public_path__ + "static/media/mustashol.d221e29b04d781d3845f3aced5424a5f.svg";
export { ForwardRef as ReactComponent };